export const ArrowLeftTinyIcon = () => (
  <svg fill="none" height="17" viewBox="0 0 10 17" width="10" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.70902 14.3807C10.0983 14.7723 10.0967 15.4054 9.70511 15.7947C9.31348 16.184 8.6804 16.1823 8.29105 15.7908L0.589879 8.04279L8.29105 0.294744C8.6804 -0.0967634 9.31347 -0.0984207 9.70511 0.290838C10.0966 0.680184 10.0983 1.31325 9.70902 1.7049L3.41019 8.04279L9.70902 14.3807Z"
      fill="white"
    />
  </svg>
);
